module.exports = __webpack_public_path__ + "static/media/speakers_logos_IBM.7ce7b982.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_IBM.jpg
// module id = 272
// module chunks = 0